export const EXCEL_EXPORT_START_MESSAGE = "Exporting current table";
export const EXCEL_EXPORT_SUCCESS_MESSAGE = "Export has been successfully created";
export const EXCEL_EXPORT_FAILURE_MESSAGE = "Error while creating an export";
